<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';

function resolveIsDark() {
  try {
    const scheme = localStorage.getItem('color_scheme') || 'auto';
    return (
      scheme === 'dark' ||
      (scheme === 'auto' &&
        window.matchMedia('(prefers-color-scheme: dark)').matches)
    );
  } catch (e) {
    return false;
  }
}

// Read localStorage at setup time — correct before body class is applied
const isDark = ref(resolveIsDark());

const logoSrc = computed(() =>
  isDark.value
    ? '/brand-assets/logo_favicon_white.png'
    : '/brand-assets/logo_favicon.png'
);

let observer = null;
onMounted(() => {
  // Re-check in case class was applied between setup and mount
  isDark.value = document.body.classList.contains('dark');
  observer = new MutationObserver(() => {
    isDark.value = document.body.classList.contains('dark');
  });
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
});
onUnmounted(() => observer && observer.disconnect());
</script>

<template>
  <img v-bind="$attrs" :src="logoSrc" />
</template>
